import axios from 'axios'
import React, { useEffect, useState } from 'react'
import FilterListIcon from '@mui/icons-material/FilterList';
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import Modal from 'react-bootstrap/Modal';
import Offcanvas from 'react-bootstrap/Offcanvas';
import dayjs from 'dayjs';
import DocViewer, { DocViewerRenderers, PDFRenderer, PNGRenderer } from "react-doc-viewer";
import PDFViewer from './PDFViewer';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from 'react-bootstrap/Pagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import morningBackground from "../images/morning.jpg"
import afternoonBackground from "../images/evening.jpg"
import nighBackground from "../images/night.jpg"
import birdthdayFrame from "../images/birthdayFrame.png"
import anniversaryFrame from "../images/anniversaryFrame.png"
import Slider from './Slider';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCameraRetro,
    faDragon,
    faFootballBall,
    faGlassCheers,
    faHelicopter
} from "@fortawesome/free-solid-svg-icons";
import CustomSpinner from '../components/CustomSpinner';


function Insights({ serverURL, user, setShowSideOverlay }) {
    const [allEntries, setAllEntries] = useState(null)
    const [allCards, setAllCards] = useState(null)

    const [activeSlide, setActiveSlide] = useState(0)

    const [liveClock, setLiveClock] = useState(dayjs().format("h:mm:ss A"));
    const [period, setPeriod] = useState(dayjs().format("HH") < 12 ? "Morning" : dayjs().format("HH") < 17 ? "Afternoon" : dayjs().format("HH") <= 24 ? "Evening" : "Noon");
    const [liveDate, setLiveDate] = useState(dayjs().format("DD"));
    const [liveMonth, setLiveMonth] = useState(dayjs().format("MMM"));
    const [liveYear, setLiveYear] = useState(dayjs().format("YYYY"));
    const [liveDay, setLiveDay] = useState(dayjs().format("dddd"));
    const [liveZone, setLiveZone] = useState(dayjs().format("Z"));

    const [eventFilter, setEventFilter] = useState({
        "today": { "start": dayjs().startOf('day').year(dayjs().format("YYYY")).valueOf(), "end": dayjs().endOf('day').year(dayjs().format("YYYY")).valueOf(), "format": { "start": dayjs().startOf('day').year(dayjs().format("YYYY")).format("YYYY-MM-DD"), "end": dayjs().endOf('day').year(dayjs().format("YYYY")).format("YYYY-MM-DD") } },
        "thisWeek": { "start": dayjs().startOf('week').year(dayjs().format("YYYY")).valueOf(), "end": dayjs().endOf('week').year(dayjs().format("YYYY")).valueOf(), "format": { "start": dayjs().startOf('week').year(dayjs().format("YYYY")).format("YYYY-MM-DD"), "end": dayjs().endOf('week').year(dayjs().format("YYYY")).format("YYYY-MM-DD") } },
        "thisMonth": { "start": dayjs().startOf('month').year(dayjs().format("YYYY")).valueOf(), "end": dayjs().endOf('month').year(dayjs().format("YYYY")).valueOf(), "format": { "start": dayjs().startOf('month').year(dayjs().format("YYYY")).format("YYYY-MM-DD"), "end": dayjs().endOf('month').year(dayjs().format("YYYY")).format("YYYY-MM-DD") } },
        "nextMonth": { "start": dayjs().add(1, 'month').startOf('month').year(dayjs().format("YYYY")).valueOf(), "end": dayjs().add(1, 'month').endOf('month').year(dayjs().format("YYYY")).valueOf(), "format": { "start": dayjs().add(1, 'month').startOf('month').year(dayjs().format("YYYY")).format("YYYY-MM-DD"), "end": dayjs().add(1, 'month').endOf('month').year(dayjs().format("YYYY")).format("YYYY-MM-DD") } },
        "previousMonth": { "start": dayjs().subtract(1, 'month').startOf('month').year(dayjs().format("YYYY")).valueOf(), "end": dayjs().subtract(1, 'month').endOf('month').year(dayjs().format("YYYY")).valueOf(), "format": { "start": dayjs().subtract(1, 'month').startOf('month').year(dayjs().format("YYYY")).format("YYYY-MM-DD"), "end": dayjs().subtract(1, 'month').endOf('month').year(dayjs().format("YYYY")).format("YYYY-MM-DD") } },
    })

    const [selectedTrigger, setSelectedTrigger] = useState(0)

    const options = [
        { value: 'today', label: 'Today' },
        { value: 'thisWeek', label: 'This Week' },
        { value: 'thisMonth', label: 'This Month' },
        { value: 'nextMonth', label: 'Next Month' },
        { value: 'previousMonth', label: 'Previous Month' },
    ];

    const backgrounds = [
        {
            backgroundImage: `url(${morningBackground})`, backgroundSize: "cover", backgroundPosition: "center 40%", backgroundRepeat: "no-repeat"
        },
        {
            backgroundImage: `url(${afternoonBackground})`, backgroundSize: "cover", backgroundPosition: "center 69%", backgroundRepeat: "no-repeat"
        },
        {
            backgroundImage: `url(${nighBackground})`, backgroundSize: "cover", backgroundPosition: "center 28%", backgroundRepeat: "no-repeat"
        }
    ]

    const logoKaBackgrounds = [
        { backgroundImage: `url(${birdthdayFrame})`, backgroundSize: "cover", backgroundPositionX: ".02em", backgroundPositionY: "-0.55em", padding: "3em" },
        { backgroundImage: `url(${anniversaryFrame})`, backgroundSize: "cover", backgroundPositionX: ".02em", backgroundPositionY: "-0.3em", padding: "3em" }
    ]

    const logoKaData = [
        {
            "id": 1,
            "name": "Gulfan Khan",
            "email": "gulfan.nutron@gmail.com",
            "eventType": "anniversary",
            "department": "IT",
            "bgColor": "#F54748",
        }
    ]

    const [allTicket, setAllTicket] = useState([])
    const [totalEntriesCount, setTotalEntriesCount] = useState(0)
    const [skipEntries, setSkipEntries] = useState(0)

    const [entriesLimit, setEntriesLimit] = useState(100)


    const syncData = async () => {

        const getAllForms = await axios.post(serverURL + "/forms/getAll")

        if (getAllForms.status === 200) {
            const allForms = getAllForms.data;
            if (allForms.length > 0) {
                const YGHEADCOUNTFORM = allForms.filter((form) => { return form.name === "YG Head Count Form" })[0]._id;

                const getAllEntries = await axios.post(serverURL + "/forms/getAllEntries", { "formRefId": YGHEADCOUNTFORM })
                if (getAllEntries.status === 200) {
                    // console.log(getAllEntries.data)


                    let commonData = []
                    let userDetails = [];
                    getAllEntries.data.map((data, key) => {
                        commonData.push(
                            {
                                "id": key,
                                "name": data.submittedData["Employee Name"],
                                "email": data.submittedData["Official Mail Id"],
                                "department": data.submittedData["Process / Department"],
                                "eventType": "anniversary",
                            }
                        )

                        userDetails.push({
                            "id": key,
                            "name": data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Employee Name") })[0]],
                            "email": data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Official Mail Id") })[0]],
                            "department": data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Process / Department") })[0]],
                            "DOB": { "formatted": data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Date of birth") })[0]], "value": dayjs(`${dayjs().format("YYYY")}-${data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Date of birth") })[0]]?.split("-")[1]}-${data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Date of birth") })[0]]?.split("-")[2]}`).valueOf() },
                            "DOJ": { "formatted": data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Date of joining") })[0]], "value": dayjs(`${dayjs().format("YYYY")}-${data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Date of joining") })[0]]?.split("-")[1]}-${data.submittedData[Object.keys(data.submittedData).filter((name) => { return name.includes("Date of joining") })[0]]?.split("-")[2]}`).valueOf() },
                        })
                    })

                    // console.log(userDetails)

                    let birthdays = userDetails.filter((user) => { return user.DOB.formatted !== "" })
                    let anniversaries = userDetails.filter((user) => { return user.DOJ.formatted !== "" })


                    const eventsData = { "BDays": birthdays, "ADays": anniversaries }

                    // console.log(eventsData)
                    setAllEntries(eventsData)

                } else {
                    console.log(getAllEntries.data)
                }
            } else {
                setAllEntries(null)
            }
        }
        else {
            console.log(getAllForms.data)
        }
    }
    const getAllTickets = async () => {
        const query = {
            "limit": entriesLimit,
            "skip": skipEntries,
        }

        const getAllTickets = await axios.post(serverURL + "/tickets/getAll", query)
        if (getAllTickets.status === 200) {
            // console.log(getAllTickets.data)
            setTotalEntriesCount(getAllTickets.data.total)

            if (getAllTickets.data.tickets.length > 0) {

                // console.log(getAllTickets.data[0].ticketNumber)
            }


            let myTicketsFiltered = getAllTickets.data.tickets.filter((ticket) => {
                if (user.userType === "admin") {
                    return true
                }

                if (ticket.tags.filter((tag) => { return tag.includes(user.email) }).length > 0) {
                    return true
                }

                return ticket.raisedTo?.value === user.email || ticket.createdBy?.email === user.email || ticket.raisedTo.otherData["Reporting Manager's Email ID"] === user.email || ticket.createdBy.reportingManager === user.manager
            })



            setAllTicket(myTicketsFiltered)

            let option = []

            myTicketsFiltered.map((user, key) => {
                return option.push({ "label": user.name, "value": user.uid })
            })

        } else {
            console.log(getAllTickets.data)
        }

    }

    useEffect(() => {
        if (allEntries) {
            setAllCards(null)
            // console.log(eventFilter[Object.keys(eventFilter)[selectedTrigger]].format)

            const startTime = eventFilter[Object.keys(eventFilter)[selectedTrigger]].start
            const endTime = eventFilter[Object.keys(eventFilter)[selectedTrigger]].end



            // dayjs(entry.DOJ.value).year(dayjs().subtract(1, "year").format("YYYY")).valueOf()


            let finalFilteredDOB = [];
            let finalFilteredDOJ = [];

            let filteredDOB = allEntries.BDays.filter((entry) => { return entry.DOB.value >= startTime && entry.DOB.value <= endTime })
            let filteredDOJ = allEntries.ADays.filter((entry) => { return entry.DOJ.value >= startTime && entry.DOJ.value <= endTime })

            filteredDOB.map((sym1, key) => {
                let data = {
                    "id": key,
                    "name": sym1.name,
                    "email": sym1.email,
                    "department": sym1.department,
                    "DOB": sym1.DOB,
                    "DOJ": sym1.DOJ,
                    "eventType": "birthday"
                }

                return finalFilteredDOB.push(data)
            })

            filteredDOJ.map((sym1, key) => {
                let data = {
                    "id": filteredDOB.length + key,
                    "name": sym1.name,
                    "email": sym1.email,
                    "department": sym1.department,
                    "DOB": sym1.DOB,
                    "DOJ": sym1.DOJ,
                    "eventType": "anniversary"
                }
                return finalFilteredDOJ.push(data)
            })


            let cardsFinalized = finalFilteredDOB.concat(finalFilteredDOJ)

            // console.log(cardsFinalized)
            if (cardsFinalized.length > 0) {
                setAllCards(cardsFinalized)
            } else {
                setAllCards(null)
            }


            setActiveSlide(Math.floor(cardsFinalized.length / 2) > 0 ? Math.floor(cardsFinalized.length / 2) - 1 : 0)

        }
    }, [selectedTrigger, allEntries])


    // useEffect(() => {
    //     getAllTickets()
    // }, [skipEntries, entriesLimit])



    useEffect(() => {
        syncData()
        // getAllTickets()
        setInterval(() => {
            setInterval(() => {
                setPeriod(dayjs().format("HH") < 12 ? "Morning" : dayjs().format("HH") < 17 ? "Afternoon" : dayjs().format("HH") < 24 ? "Evening" : "Noon")
                setLiveClock(dayjs().format("h:mm:ss A"));
                setLiveDate(dayjs().format("DD"));
                setLiveMonth(dayjs().format("MMM"));
                setLiveYear(dayjs().format("YYYY"));
                setLiveDay(dayjs().format("dddd"));
                setLiveZone(dayjs().format("Z"));
            }, 1000)
        }, 1000)
    }, [])
    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                {/* <div className="headerUserDetails py-1 mb-3 d-flex justify-content-between" onClick={() => { syncData() }}>
                    <span>Home</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div> */}
                <div className='w-100 h-100 overflow-auto d-flex flex-column gap-3'>
                    <div className="d-none d-lg-flex d-xl-flex d-xxl-flex justify-content-between align-items-start flex-wrap rounded p-2" style={period === "Morning" ? backgrounds[0] : period === "Afternoon" ? backgrounds[1] : backgrounds[2]}>
                        <span></span>
                        {/* <div className='h-100 w-md-100 text-center d-flex flex-row justify-content-end align-items-center cardsTransparentFade'>
                                <span className='fs-3 text-light'>Good {period}, {user.name}</span>
                            </div> */}
                        <div className='h-100 w-md-100 text-center d-flex flex-row justify-content-end align-items-center gap-3 text-light cardsTransparentFade'>
                            <div className='d-flex gap-1 justify-content-start'>
                                <div className='d-flex flex-column justify-content-center'>
                                    <span className='clockDate' style={{ fontSize: "3rem", fontWeight: "400", lineHeight: "2.6rem" }}>
                                        {
                                            liveDate
                                        }
                                    </span>
                                </div>
                                <div className='d-flex flex-column justify-content-center' style={{ fontWeight: "500" }}>
                                    <span className='clockMonth'>
                                        {
                                            liveMonth
                                        }
                                    </span>
                                    <span className='clockYear'>
                                        {
                                            liveYear
                                        }
                                    </span>
                                </div>
                            </div>
                            <div className='d-flex flex-column'>
                                <div className='w-100 d-flex gap-1 justify-content-start align-items-center' style={{ fontWeight: "500" }}>
                                    <span className='clockTime'>
                                        {
                                            liveClock
                                        }
                                    </span>
                                </div>
                                <div className='w-100 d-flex gap-1 justify-content-start align-items-center' style={{ fontWeight: "500" }}>
                                    <span className='clockDay'>
                                        {
                                            liveDay
                                        }
                                    </span>
                                    <span className='clockZone'>
                                        {
                                            liveZone
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex d-lg-none d-xl-none d-xxl-none justify-content-between align-items-start flex-wrap rounded p-2" style={period === "Morning" ? backgrounds[0] : period === "Afternoon" ? backgrounds[1] : backgrounds[2]}>
                        <div className='h-100 w-100 text-center d-flex flex-row justify-content-between align-items-center cardsTransparentFade flex-wrap gap-2'>
                            <span></span>
                            {/* <span className='fs-3 text-light'>Good {period}</span> */}
                            <div className='h-100 w-md-100 text-center d-flex flex-row justify-content-end align-items-center gap-3 text-light'>
                                <div className='d-flex gap-1 justify-content-start'>
                                    <div className='d-flex flex-column justify-content-center'>
                                        <span className='clockDate' style={{ fontSize: "3rem", fontWeight: "400", lineHeight: "2.6rem" }}>
                                            {
                                                liveDate
                                            }
                                        </span>
                                    </div>
                                    <div className='d-flex flex-column justify-content-center' style={{ fontWeight: "500" }}>
                                        <span className='clockMonth'>
                                            {
                                                liveMonth
                                            }
                                        </span>
                                        <span className='clockYear'>
                                            {
                                                liveYear
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div className='d-flex flex-column'>
                                    <div className='w-100 d-flex gap-1 justify-content-start align-items-center' style={{ fontWeight: "500" }}>
                                        <span className='clockTime'>
                                            {
                                                liveClock
                                            }
                                        </span>
                                    </div>
                                    <div className='w-100 d-flex gap-1 justify-content-start align-items-center' style={{ fontWeight: "500" }}>
                                        <span className='clockDay'>
                                            {
                                                liveDay
                                            }
                                        </span>
                                        <span className='clockZone'>
                                            {
                                                liveZone
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='h-100 w-100 overflow-auto'>
                        <div className="container-fluid h-100">
                            <div className="row h-100">
                                <div className="col-12 h-100">
                                    <div className="d-flex flex-column gap-3 w-100">
                                        <div className='d-flex justify-content-center justify-content-lg-between  flex-wrap align-items-center px-5 py-3 gap-lg-5 gap-3 rounded-4 w-100' style={{ background: "#ffd300" }}>
                                            <div className='d-flex justify-content-between flex-column'>
                                                <h1 className='display-5 fw-bold'>Good {period}</h1>
                                                <h1 className='fs-3 fw-bold'>{user.name}</h1>
                                                <p className='fs-6'>Always stay updated in YG Portal</p>
                                            </div>
                                            <div className='d-flex flex-column align-items-center gap-2'>
                                                <div className='w-100 bg-light p-5 rounded-circle' style={{ maxWidth: "100px", aspectRatio: "1", backgroundSize: "cover", backgroundImage: `url(https://placehold.co/600x600/FFFFFF/898989?text=${user.name.split(" ").map((word, key) => { return String(word).toLocaleUpperCase()[0] }).join("+")})` }}></div>
                                                <span className='text-center text-nowrap fw-bold'>{user.department}</span>
                                            </div>
                                        </div>
                                        <div className='p-0 d-flex justify-content-between w-100'>
                                            <div className='cardsTransparent d-flex flex-column justify-content-start align-items-start gap-2 w-100 overflow-hidden '>
                                                <div className='w-100 d-flex h-100 justify-content-center align-items-center p-2 mb-3 cardsTransparent overflow-hidden'>
                                                    <button className='navigationCustomButtons' onClick={(e) => { if (selectedTrigger > 0) { setSelectedTrigger(selectedTrigger - 1) } else { setSelectedTrigger(options.length - 1) } }} ><KeyboardArrowLeftIcon className='p-0 d-flex align-items-center' style={{ fontSize: "1.1rem" }} /></button>
                                                    <span className='px-2 text-center text-nowrap text-trucate w-100' style={{ background: "none", maxWidth: "180px" }} >{options[selectedTrigger].label}</span>
                                                    <button className='navigationCustomButtons' onClick={(e) => { if (selectedTrigger < options.length - 1) { setSelectedTrigger(selectedTrigger + 1) } else { setSelectedTrigger(0) } }} ><KeyboardArrowRightIcon className='p-0 d-flex align-items-center' style={{ fontSize: "1.1rem" }} /></button>
                                                </div>
                                                <div className='w-100' style={{ fontSize: ".6em" }}>
                                                    {
                                                        allCards ?
                                                            <Slider data={allCards} activeSlide={activeSlide} setActiveSlide={setActiveSlide} logoKaBackgrounds={logoKaBackgrounds} />
                                                            :
                                                            <div className='w-100 d-flex align-items-center fs-4 justify-content-center text-secondary text-center'>No events available</div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className='w-100 cardsTransparent d-flex gap-5'>
                                            {/* To Do and Tickets Hidden Here */}
                                            <div className="container-fluid d-none">
                                                <div className="row">
                                                    <div className="col-12 col-xl-6 mb-3">
                                                        <div className='w-100 overflow-auto'>
                                                            <p className='text-center m-0 py-1 fw-bold '>To Do</p>
                                                            <div className='w-100 overflow-auto'>
                                                                <table className='table m-0 table-hover'>
                                                                    <thead className='table-info sticky-top'>
                                                                        <tr align="center">
                                                                            <th className='text-nowrap'>#{totalEntriesCount}</th>
                                                                            <th className='text-nowrap'>Creation Date</th>
                                                                            <th className='text-nowrap'>Ticket ID</th>
                                                                            <th className='text-nowrap'>Ticket Status</th>
                                                                            <th className='text-wrap' style={{ maxWidth: "300px" }}>Subject</th>
                                                                            <th className='text-nowrap'>Department</th>
                                                                            <th className='text-nowrap'>Sub Department</th>
                                                                            <th className='text-nowrap'>Created By</th>
                                                                            <th className='text-nowrap'>Assigned To</th>
                                                                        </tr>
                                                                    </thead>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-xl-6 mb-3">
                                                        <div className='w-100 overflow-auto'>
                                                            <p className='text-center m-0 py-1 fw-bold '>Tickets</p>
                                                            <div className='w-100 overflow-auto'>
                                                                <table className='table m-0 table-hover'>
                                                                    <thead className='table-info sticky-top'>
                                                                        <tr align="center">
                                                                            <th className='text-nowrap'>#{totalEntriesCount}</th>
                                                                            <th className='text-nowrap'>Creation Date</th>
                                                                            <th className='text-nowrap'>Ticket ID</th>
                                                                            <th className='text-nowrap'>Ticket Status</th>
                                                                            <th className='text-wrap' style={{ maxWidth: "300px" }}>Subject</th>
                                                                            <th className='text-nowrap'>Department</th>
                                                                            <th className='text-nowrap'>Sub Department</th>
                                                                            <th className='text-nowrap'>Created By</th>
                                                                            <th className='text-nowrap'>Assigned To</th>
                                                                            {/* <th className='text-nowrap'>Description</th> */}
                                                                            <th className='text-nowrap'>Priority</th>
                                                                            <th className='text-nowrap'>Last Modified</th>
                                                                            {/* <th className='text-nowrap'>Student ID</th>
                                                                                    <th className='text-nowrap'>Branch</th>
                                                                                    <th className='text-nowrap'>Deadline</th>
                                                                                    <th className='text-nowrap'>Overdue</th>
                                                                                    <th className='text-nowrap'>Assigned Status</th>
                                                                                    <th className='text-nowrap'>Assigned To</th>
                                                                                    <th className='text-nowrap'>Escalation To</th> */}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            allTicket.length > 0 ?
                                                                                allTicket.map((ticket, key) => {
                                                                                    return (
                                                                                        <tr align="center" key={key}>
                                                                                            <td valign='middle' className="text-nowrap">{skipEntries + (key + 1)}</td>
                                                                                            <td valign='middle' className="text-nowrap">{dayjs(ticket.createdAt).format("DD MMM YYYY, h:mma")}</td>
                                                                                            <td valign='middle' className="text-nowrap">YG{ticket.ticketNumber?.toString().padStart(8, '0')}</td>
                                                                                            <td valign='middle' className="text-nowrap" style={ticket.createdBy.uid !== user.uid ? { cursor: "pointer" } : {}} >
                                                                                                {
                                                                                                    ticket.status?.value === "open" ?
                                                                                                        <div className='alert alert-secondary p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                            {ticket.status?.value}
                                                                                                        </div>
                                                                                                        :
                                                                                                        ticket.status?.value === "in-process" ?
                                                                                                            <div className='alert alert-info p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                                {ticket.status?.value}
                                                                                                            </div>
                                                                                                            :
                                                                                                            ticket.status?.value === "closed" ?
                                                                                                                <div className='alert alert-success p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                                    {ticket.status?.value}
                                                                                                                </div>
                                                                                                                :
                                                                                                                ticket.status?.value === "reopen" ?
                                                                                                                    <div className='alert alert-warning p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                                        {ticket.status?.value}
                                                                                                                    </div>
                                                                                                                    :
                                                                                                                    <div className='alert alert-danger p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                                        {ticket.status?.value}
                                                                                                                    </div>
                                                                                                }
                                                                                            </td>
                                                                                            <td valign='middle'>
                                                                                                <p className="text-start text-nowrap text-truncate w-100 m-0" style={{ maxWidth: "550px" }} title={ticket.subject}>{ticket.subject}</p>
                                                                                            </td>
                                                                                            <td valign='middle' className="text-nowrap">{ticket.department?.label}</td>
                                                                                            <td valign='middle'>
                                                                                                <div className='d-flex flex-wrap justify-content-center gap-2'>
                                                                                                    {
                                                                                                        ticket.subDepartment?.map((subDep, key) => {
                                                                                                            return (
                                                                                                                subDep.label
                                                                                                            )
                                                                                                        })
                                                                                                    }
                                                                                                </div>
                                                                                            </td>
                                                                                            <td valign='middle' className="text-nowrap" title={ticket.createdBy?.email}>{ticket.createdBy?.name}</td>
                                                                                            <td valign='middle' className="text-nowrap" onClick={() => { }}>{ticket.raisedTo?.label}</td>
                                                                                            <td valign='middle' className="text-nowrap">{ticket.priority?.label}</td>
                                                                                            <td valign='middle' className="text-nowrap">{dayjs(ticket.updatedAt).format("DD MMM YYYY, h:mma")}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                <tr align="center">
                                                                                    <td colSpan={19} valign='middle'>No Data</td>
                                                                                </tr>
                                                                        }

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-12 d-none d-xxl-flex col-xxl-3 h-100">
                                    <div className='bg-dark rounded-4 px-0 py-2 h-100 w-100 d-flex flex-column overflow-auto'>
                                        <div className='fs-4 px-2 mb-2 fw-normal text-center w-100' style={{ color: "#ffd300" }}>
                                            Notifications
                                        </div>
                                        <div className='d-flex flex-column gap-2 pb-3 px-3 overflow-auto align-items-start'   >

                                            {
                                                [12, 31, 23, 213, 21, 3, 21, 1232, 32, , 24, 234, 32, 4, 324, 23, 4, 324, 23, 4, 234, 234, 32, 432, 4, 324, 32, 432, 4, 324, 32, 423, 4, 324, 32, 432, 432, 432, 4324, 1].map((not, key) => {
                                                    return (
                                                        key % 10 !== 0 ?
                                                            <p className='text-light d-flex gap-3 align-items-center m-0 w-100' key={key} style={{ fontSize: "13px" }}>
                                                                <span className='text-dark rounded-3 px-1' style={{ background: "#ffd300", lineHeight: "17px", fontWeight: "500" }} >{dayjs().add(not, "minutes").format("h:mm A")}</span>
                                                                Someone tagged you in ticket
                                                            </p>
                                                            :
                                                            <div className='d-flex align-items-center w-100' key={key}>
                                                                <hr className='w-100 text-light' color='white' />
                                                                <span className='text-start rounded-pill bg-light text-dark px-2 w-100 text-nowrap' style={{ fontSize: "13px", fontWeight: "500" }}>{dayjs().format("dddd, DD MMMM YYYY")}</span>
                                                                <hr className='w-100 text-light' color='white' />
                                                            </div>
                                                    )
                                                })
                                            }




                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Insights